import React,{useState,useEffect,useRef} from 'react'
import { checkEmptyValue } from '../../../plugins/common'


const metricFieldMap = {
        'P Ons': 'ponset',
        'P Dur': 'pdur',
        'QRS Ons': 'qrson',
        'QRS Dur': 'qrsdur',
        'ST80 Amp': 'st80amp',
        'Q Dur': 'qdur',
        'R Dur': 'rdur',
        'S Dur': 'sdur',
        'R\' Dur': 'r2dur', // API에 없는 필드, 기본값 처리 필요
        'S\' Dur': 's2dur', // API에 없는 필드, 기본값 처리 필요
        'R\'\' Dur': 'r3dur', // API에 없는 필드, 기본값 처리 필요
        'S\'\' Dur': 's3dur', // API에 없는 필드, 기본값 처리 필요
        'ST Dur': 'stdur',
        'T Ons': 'ton',
        'T Dur': 'tdur',
        'P+ Amp': 'pamp',
        'P- Amp': 'pnegamp', // API에 없는 필드, 기본값 처리 필요
        'P2P Amp': 'p2pamp', // API에 없는 필드, 기본값 처리 필요
        'R1 Amp': 'r1amp',
        'Q Amp': 'qamp',
        'R Amp': 'ramp',
        'S Amp': 'samp',
        'R\' Amp': 'r2amp',
        'S\' Amp': 's1amp',
        'R\'\' Amp': 'r3amp', // API에 없는 필드, 기본값 처리 필요
        'S\'\' Amp': 's2amp', // 
        'ST Amp': 'stamp',
        'STT28 Amp': 'st28amp',
        'STT38 Amp': 'st38amp',
        'T+ Amp': 'tposamp',
        'T- Amp': 'tnegamp',
        'QRS Area': 'qrsarea',
        'P Area': 'parea',
        'T Area': 'tarea',
        'P Morph': 'pmorph',
        'T Morph': 'tmorph',
        'R Notch': 'rnotches',
        'DeltaConf': 'deltaconf',
        'ST Slope': 'stslope',
        'QT Int': 'qtinterval'
    }

const MetricTable = ({ metricData, typeByLeadLabel }) => {
    const isFirstRender = useRef(true);
    
    return (
        <div className='w-full flex flex-col'>
            <div className='w-full flex border-t-[4px] border-[#5D5D5D]'>
                <div className="flex flex-col">
                    {
                        ['', 'LEADⅠ', 'LEADⅡ', 'LEADⅢ', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'].map((lead, index) => {
                            return (
                                <div 
                                    className="flex justify-center items-center font-light text-[#000] text-[28px]" 
                                    style={{ 
                                        height: index === 0 ? 80 : 64,
                                        paddingLeft: 8,
                                        paddingBottom: index === 12 ? 6 : 0,                                                                                
                                        borderStyle: 'solid',
                                        borderColor: '#5D5D5D',
                                        borderTopWidth: 0,      
                                        borderLeftWidth: 0,
                                        borderBottomWidth: '1px',
                                        borderRightWidth: '1px',
                                        minWidth: 180,
                                        maxWidth: 180
                                    }} key={`table-lead-type-${lead}`}>{lead}</div>
                            )
                        })
                    }
                </div>
                <div className='w-full flex'>
                    {
                        ['P Ons', 'P Dur', 'QRS Ons', 'QRS Dur', 'ST80 Amp', 'Q Dur', 'R Dur', 'S Dur', 'R’ Dur', 'S’ Dur', 'R’’ Dur', 'S’’ Dur', 'ST Dur', 'T Ons', 'T Dur', 'P+ Amp', 'P- Amp', 'P2P Amp', 'R1 Amp', 'Q Amp'].map((value, index) => {                            
                            return (
                                <div className="flex flex-1 flex-col flex-shrink-0 gap-[1px]" style={{ minWidth: 140, width: 'auto' }} key={`table-value-type-${value}`}>
                                    <div
                                        style={{
                                            paddingLeft: 8,
                                            paddingRight: 8,
                                            whiteSpace: 'nowrap',
                                        }}
                                        className="flex justify-center items-center h-[80px] font-medium text-[#5D5D5D] text-[28px] border-b-[1px] border-[#AEAEAE]"
                                    >
                                            {value}
                                    </div>
                                    {
                                        ['LEADⅠ', 'LEADⅡ', 'LEADⅢ', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'].map((lead, index) => {
                                            return (
                                                <div className="flex-1 flex items-center justify-center h-[64px] bg-white font-light text-[#5D5D5D] text-[32px] border-b-[1px] border-[#AEAEAE]" key={`table-lead-value-${lead}`}>{checkEmptyValue(metricData[typeByLeadLabel[lead] || lead] ? metricData[typeByLeadLabel[lead] || lead][metricFieldMap[value]] : null)}</div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className='w-full flex border-t-[4px] border-[#5D5D5D]'>
                <div className="flex flex-col">
                    {
                        ['', 'LEADⅠ', 'LEADⅡ', 'LEADⅢ', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'].map((lead, index) => {
                            return (
                                <div 
                                    className="flex justify-center items-center font-light text-[#000] text-[28px]" 
                                    style={{ 
                                        height: index === 0 ? 80 : 64,
                                        paddingLeft: 8,
                                        paddingBottom: index === 12 ? 6 : 0,                                                                                
                                        borderStyle: 'solid',
                                        borderColor: '#5D5D5D',
                                        borderTopWidth: 0,      
                                        borderLeftWidth: 0,
                                        borderBottomWidth: '1px',
                                        borderRightWidth: '1px',
                                        minWidth: 180,
                                        maxWidth: 180
                                    }} key={`table-lead-type-${lead}`}>{lead}</div>
                            )
                        })
                    }
                </div>
                <div className='w-full flex'>
                    {
                        ['R Amp', 'S Amp', 'R’ Amp', 'S’ Amp', 'R’’ Amp', 'S’’ Amp', 'ST Amp', 'STT28 Amp', 'STT38 Amp', 'T+ Amp', 'T- Amp', 'QRS Area', 'P Area', 'T Area', 'P Morph', 'T Morph', 'R Notch', 'DeltaConf', 'ST Slope', 'QT Int'].map((value, index) => {                            
                            return (
                                <div className="flex flex-1 flex-col flex-shrink-0 gap-[1px]" style={{ minWidth: 140, width: 'auto' }} key={`table-value-type-${value}`}>
                                    <div
                                        style={{
                                            paddingLeft: 8,
                                            paddingRight: 8,
                                        }}
                                        className="flex w-full justify-center items-center text-center h-[80px] font-medium text-[#5D5D5D] text-[28px] border-b-[1px] border-[#AEAEAE]"
                                    >
                                            {value}
                                    </div>
                                    {
                                        ['LEADⅠ', 'LEADⅡ', 'LEADⅢ', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'].map((lead, index) => {
                                            return (
                                                <div className="flex-1 flex items-center justify-center h-[64px] bg-white font-light text-[#5D5D5D] text-[32px] border-b-[1px] border-[#AEAEAE]" key={`table-lead-value-${lead}`}>{checkEmptyValue(metricData[typeByLeadLabel[lead] || lead] ? metricData[typeByLeadLabel[lead] || lead][metricFieldMap[value]] : null)}</div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default MetricTable